import { render } from "./global_notice_list.vue?vue&type=template&id=f53eca8e"
import script from "./global_notice_list.js?vue&type=script&lang=js"
export * from "./global_notice_list.js?vue&type=script&lang=js"

import "./global_notice_list.vue?vue&type=style&index=0&id=f53eca8e&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__